(function () {
  "use strict";

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function searchUrl(query, limit) {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
    return root + "search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product,collection,page,article&resources[limit]=" + limit;
  }

  function renderResults(container, data, showPrice) {
    var resources = data.resources && data.resources.results ? data.resources.results : {};
    var products = resources.products || [];
    var collections = resources.collections || [];
    var pages = resources.pages || [];
    var articles = resources.articles || [];
    var html = "";

    products.forEach(function (product) {
      var image = product.image ? '<img src="' + product.image + '" alt="' + product.title.replace(/"/g, "&quot;") + '" loading="lazy">' : '<div class="imagine-placeholder-media"></div>';
      html += '<a class="imagine-search-result" href="' + product.url + '">' + image + '<span><strong>' + product.title + '</strong>' + (showPrice && product.price ? '<br><small>' + product.price + '</small>' : '') + '</span></a>';
    });
    collections.forEach(function (collection) {
      html += '<a class="imagine-search-result" href="' + collection.url + '"><div class="imagine-placeholder-media"></div><span><strong>' + collection.title + '</strong><br><small>Collection</small></span></a>';
    });
    pages.concat(articles).forEach(function (item) {
      html += '<a class="imagine-search-result" href="' + item.url + '"><div class="imagine-placeholder-media"></div><span><strong>' + item.title + '</strong></span></a>';
    });

    container.innerHTML = html || '<div class="imagine-empty">No results found.</div>';
  }

  function init(root) {
    qsa("[data-imagine-search-drawer]", root).forEach(function (drawer) {
      if (drawer.dataset.imagineSearchBound) return;
      drawer.dataset.imagineSearchBound = "true";
      var form = drawer.querySelector("[data-imagine-search-form]");
      var input = drawer.querySelector("[data-imagine-search-input]");
      var results = drawer.querySelector("[data-imagine-search-results]");
      var limit = Number(drawer.getAttribute("data-maximum-results") || 6);
      var showPrice = drawer.getAttribute("data-show-product-price") === "true";
      var controller = null;

      if (!form || !input || !results) return;

      form.addEventListener("submit", function (event) {
        if (!input.value.trim()) event.preventDefault();
      });

      input.addEventListener("input", function () {
        var query = input.value.trim();
        if (controller) controller.abort();
        if (!query) {
          results.innerHTML = '<div class="imagine-empty">Start typing to search.</div>';
          return;
        }
        controller = new AbortController();
        results.innerHTML = '<div class="imagine-empty">Searching...</div>';
        fetch(searchUrl(query, limit), { signal: controller.signal, credentials: "same-origin" })
          .then(function (response) { return response.json(); })
          .then(function (data) { renderResults(results, data, showPrice); })
          .catch(function (error) {
            if (error.name !== "AbortError") results.innerHTML = '<div class="imagine-empty">Search is unavailable right now.</div>';
          });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  window.ImagineSearch = { init: init };
})();
